
import { hitApi, ObservableAjax } from '__common/utils/api';
import { ActionTypes } from 'actionsConstants';
import { SHOW_FAQ_WINDOW, POPULATE_FAQ_DATA } from './FaqActions';
import { safeOfType as ofType } from '__common/utils/safeOfType';
import { Store } from 'redux';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export function faqList(action$: Observable<any>, state$: Observable<appState>): Observable<any> {
  return action$.pipe(
    ofType(ActionTypes.POPULATE_FAQ_DATA),
    switchMap(action =>
      ObservableAjax({
        onSuccess: (data) => SHOW_FAQ_WINDOW(data),
        onErrorMessage: 'Could not fetch faq data',
        link: hitApi('get', `api/v1/faqs/`),
      }))
  );
}
